module.exports = __webpack_public_path__ + "img/verkleidung.a7f1a766.jpg";